import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { translate } from '@jsverse/transloco';
import { inject } from '@angular/core';
import { ServiceUrls } from '@libs/vc-core-lib';
import { catchError, throwError } from 'rxjs';
import { NotificationService } from 'vcp-common-ui-lib';

export const assessmentsErrorStatusInterceptor: HttpInterceptorFn = (req, next) => {
    const notificationService = inject(NotificationService);
    return next(req).pipe(
        catchError((error: HttpErrorResponse) => {
            if (serviceUrls.some((serviceUrl) => req.url.includes(serviceUrl))) {
                if ([HttpStatusCode.REQUEST_TIMEOUT, HttpStatusCode.TOO_MANY_REQUEST].includes(error.status)) {
                    notificationService.error(translate('CORE.ERROR_STATUS.SYSTEM_BUSY_TRY_AGAIN_NOTIFICATION'));
                } else if (HttpStatusCode.CONFLICT === error.status) {
                    notificationService.error(
                        translate('CORE.ERROR_STATUS.ANOTHER_USER_WORKING_TRY_AGAIN_NOTIFICATION')
                    );
                }
            }
            return throwError(() => error);
        })
    );
};

const serviceUrls: string[] = [ServiceUrls.VC_ASSESSMENT_BASE_URL, ServiceUrls.VC_FRAMEWORK_BASE_URL];

enum HttpStatusCode {
    REQUEST_TIMEOUT = 408,
    CONFLICT = 409,
    TOO_MANY_REQUEST = 429,
}
